// extracted by mini-css-extract-plugin
module.exports = {"root":"NodeHoverWrapper_root__UpPsg"};